export default {
  state: {
    dealers:{},
    objects:{},
    masters:{},
  },
  mutations: {
    set_dealers(state, value) {
      let map = {}
      for (let item of value) {
        map[item.id] = item
      }
      state.dealers = map
    },
    set_objects(state, value) {
      let map = {}
      for (let item of value) {
        map[item.id] = item
      }
      state.objects = map
    },
    set_masters(state, value) {
      let map = {}
      for (let item of value) {
        map[item.id] = item
      }
      state.masters = map
    }
  },
  actions: {
    async load_dealers({ dispatch, commit }) {
      let r = await dispatch('api_request', {endpoint: '/dealers'})
      commit('set_dealers', r)
    },
    async load_objects({ dispatch, commit }) {
      let r = await dispatch('api_request', {endpoint: '/objects'})
      commit('set_objects', r)
    },
    async load_masters({ dispatch, commit }) {
      let r = await dispatch('api_request', {endpoint: '/masters'})
      commit('set_masters', r)
    },
    async load_masters_by_object({dispatch}, object_id) {
      return await dispatch('api_request', {endpoint: `/masters?object_id=${object_id}`})
    }
  },
  getters: {
    master(state){
      return (master_id) => {
        return state.masters[master_id]
      }
    },
    dealer(state){
      return (dealer_id) => {
        return state.dealers[dealer_id]
      }
    },
    object(state){
      return (object_id) => {
        return state.objects[object_id]
      }
    },
    masters(state){
      return Object.values(state.masters)
    },
    dealers(state){
      return Object.values(state.dealers)
    },
    objects(state){
      return Object.values(state.objects)
    },
    objects_of_dealer(_, getters){
      return (dealer_id) => {
        return getters.objects.filter(el => el.dealer_id == dealer_id)
      }
    }
  }
}